import { useContext } from "react";
import { Sms } from "Context/context";

export default function useSms() {
  return useContext(Sms);
}
